import {isAfter, isBefore, startOfDay, startOfToday} from 'date-fns';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export const getCampaignStatus = (validFrom: Date | Nullish, validTo: Date | Nullish) => {
  if (isNil(validFrom) || isNil(validTo)) {
    return null;
  }

  const today = startOfToday();

  if (isAfter(startOfDay(validFrom), today)) {
    return 'SCHEDULED';
  }

  if (isBefore(startOfDay(validTo), today)) {
    return 'ENDED';
  }

  return 'ACTIVE';
};
